import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "../OnlineLeftSidebar/OnlineLeftSidebar.css"

interface OnlineLeftSidebarProps {
  currentUserId: string | number;
}

interface OnlineUser {
  id: string | number;
  display_name: string;
  last_active: string; // ISO string
  profile_picture?: string;
  email?: string;
}

const OnlineLeftSidebar: React.FC<OnlineLeftSidebarProps> = ({ currentUserId }) => {
  const [onlineUsers, setOnlineUsers] = useState<OnlineUser[]>([]);

  useEffect(() => {
    const fetchOnlineUsers = async () => {
      try {
        const now = Date.now();
        const { data } = await axios.get(`${process.env.REACT_APP_CORE_SERVER_URL}/users/online?role=core-command-administrator&lastHours=24`, {
          withCredentials: true,
        });

        // Filter out current user and ensure last_active within 24h
        const filtered = data.filter((u: OnlineUser) => {
          const lastActive = new Date(u.last_active).getTime();
          return u.id !== currentUserId && now - lastActive <= 24 * 60 * 60 * 1000;
        });

        setOnlineUsers(filtered);
      } catch (err) {
        console.error('Error fetching online users:', err);
      }
    };

    fetchOnlineUsers();

    const interval = setInterval(fetchOnlineUsers, 30_000); // refresh every 30s
    return () => clearInterval(interval);
  }, [currentUserId]);

  return (
    <div className="online-left-sidebar">
      <h3><i className="fa fa-users"></i> Online (Last 24h)</h3>
      {onlineUsers.length === 0 ? (
        <p>User activity coming soon.</p>
      ) : (
        <ul>
          {onlineUsers.map(user => (
            <li key={user.id} className="online-user-item">
              {user.profile_picture ? (
                <img src={`${process.env.REACT_APP_CORE_SERVER_URL}/${user.profile_picture}`} alt={user.display_name} />
              ) : (
                <div className="placeholder-avatar" />
              )}
              <span>{user.display_name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OnlineLeftSidebar;
